export default __webpack_public_path__ + "static/media/logo.df916fa8.png";